import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import NavBar from './components/NavBar'
import ProtectedRoute from './components/ProtectedRoute'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import OAuthCallbackPage from './pages/OAuthCallbackPage'
import TradeApplicationsListPage from './pages/TradeApplicationsListPage'
import TradeApplicationShowPage from './pages/TradeApplicationShowPage'
import ReVerifyUploadPage from './pages/ReVerifyUploadPage'
import AdminUsersPage from './pages/AdminUsersPage'
import AdminActivityPage from './pages/AdminActivityPage'
import AdminEmailTemplatesPage from './pages/AdminEmailTemplatesPage'

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<OAuthCallbackPage />} />
          {/* Public, token-gated re-verification upload page (no auth) */}
          <Route path="/re_verify/:token" element={<ReVerifyUploadPage />} />
          <Route
            path="/trade_applications"
            element={
              <ProtectedRoute>
                <TradeApplicationsListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trade_applications/:id"
            element={
              <ProtectedRoute>
                <TradeApplicationShowPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute requireRole="admin">
                <AdminUsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/activity"
            element={
              <ProtectedRoute requireRole="admin">
                <AdminActivityPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/email_templates"
            element={
              <ProtectedRoute requireRole="admin">
                <AdminEmailTemplatesPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}
